import useCart from 'hooks/account/cart/useCart'
import { useEffect, useState } from 'react'
import { config } from 'theme/molecules/account/CartSummary/ShareCart/share-cart-config'
import { CustomTailorConfig } from '../types'

/**
 * @firescoutMockFn account.useShareCart
 * manages the share cart functionality. it posts the cart which should be shared, and
 * fetches the shared cart.
 * as long as the hash is not found in the parameter of the url, setup is false.
 * otherwise setup is set to true, after all current items from cart are removed, and new items
 * are fetched.
 */
export default function useShareCart() {
  const cart = useCart()
  const [setup, setSetup] = useState(false)
  const [setupFetch, setSetupFetch] = useState(false)
  const [loading, setLoading] = useState(false)
  const [docId, setDocId] = useState<string>('')
  const [error, setError] = useState<boolean>(false)
  const shareRegex = /share=(.*)/
  const hash =
    (typeof window !== 'undefined' &&
      shareRegex.exec(window.location.search)?.[1]) ||
    ''

  useEffect(() => {
    if (!hash) setSetup(true)
    if (hash) {
      setSetupFetch(true)
      const fetchData = async () => {
        const res = await fetch(config.shareCart.netlifyGetFn, {
          method: 'POST',
          body: JSON.stringify({
            hash: hash
          })
        })
        res.json().then(async (res) => {
          const currentCartItemIds: string[] = cart.data.items.map(
            (item) => item.cartItemId
          )
          if (!res) {
            setSetup(true)
            window.history.pushState(null, '', window.location.pathname)
            setSetupFetch(false)
            setError(true)
          } else {
            const sharedItems = res.items.map((item: Item) => ({
              type: 'product',
              quantity: item.quantity,
              referencedId: item.sw6Uuid,
              customProductData: item.customProductData
            }))
            if (cart.data.hash !== 'empty') {
              window.history.pushState(null, '', window.location.pathname)
              await cart.removeItemBatch(currentCartItemIds)
              await cart.addItemBatch(sharedItems)
              setSetupFetch(false)
            }
          }
        })
      }
      fetchData()
    }
  }, [cart])

  const postCart = () => {
    const items: any = []
    cart.data.items.map((item) => {
      items.push({
        cartItemId: item.cartItemId,
        quantity: item.quantity,
        sw6Uuid: item.sw6Uuid,
        customProductData: item.customTailor
      })
    })
    setLoading(true)
    fetch(config.shareCart.netlifyPostFn, {
      method: 'POST',
      body: JSON.stringify({ items })
    })
      .then((res) => res.json().then((res) => setDocId(res.id)))
      .finally(() => setLoading(false))
  }

  return { loading, postCart, setup, docId, setupFetch, error }
}

type Item = {
  quantity: number
  cartItemId: string
  sw6Uuid: string
  customProductData: CustomTailorConfig
}
